import { env } from 'utils/envManager/envManager'
import { url } from 'utils/url/url'

import type { AuthOrchestratorData } from '../types/auth'

const ORQUESTRATOR_INFO_SERVICE_ENDPOINT = url(
	`${env.NEXT_PUBLIC_SITE_BASE_URL}/ws-auth-orchestrator/auth/info`,
	{ channel: env.NEXT_PUBLIC_CHANNEL, app: env.NEXT_PUBLIC_IS_APP }
)

export const authInfoOrchestratorService =
	async (): Promise<AuthOrchestratorData> => {
		const response = await fetch(ORQUESTRATOR_INFO_SERVICE_ENDPOINT, {
			next: { revalidate: 0 },
		})

		if (!response.ok) {
			throw new Error(`[Auth Orchestrator Service] HTTP ${response.status}`)
		}

		return response.json()
	}
